/*
  AUTHOR - KHYATI RADADIYA
  COMPANY NAME - RADIX ANALYTICS
  Version - 1
  Change log
    ----------------------------------------------------------
    Date         Author   Comment
    ----------------------------------------------------------
    2023-12-11	  Khyati   This is user data list reducer file
*/

import {
  GET_USER_DATA_REQUEST,
  GET_USER_DATA_SUCCESS,
  GET_USER_DATA_FAILURE,
} from "../../actions/types";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const GetUserDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_DATA_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_USER_DATA_SUCCESS:
      return { ...state, data: action.payload, loading: false, error: null };
    case GET_USER_DATA_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default GetUserDataReducer;
